import { OverlayRef, Overlay, OverlayConfig } from '@angular/cdk/overlay';
import { CdkPortal } from '@angular/cdk/portal';
import { Component, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';

@Component({
    selector: 'app-bciti-select-list-dropdown',
    templateUrl: './bciti-select-list-dropdown.component.html',
    styleUrls: ['./bciti-select-list-dropdown.component.scss'],
})
export class BcitiSelectListDropdownComponent {
    @Input() public reference: HTMLElement;
    @ViewChild(CdkPortal) public contentTemplate: CdkPortal;

    @Output() onClose = new EventEmitter();

    protected overlayRef: OverlayRef;
    public showing = false;

    constructor(protected overlay: Overlay) {}

    public show() {
        this.overlayRef = this.overlay.create(this.getOverlayConfig());
        this.overlayRef.attach(this.contentTemplate);
        this.syncWidth();
        this.overlayRef.backdropClick().subscribe(() => this.hide());
        this.showing = true;
    }

    public hide() {
        this.overlayRef.detach();
        this.showing = false;
        this.onClose.emit();
    }

    @HostListener('window:resize')
    public onWinResize() {
        this.syncWidth();
    }

    private syncWidth() {
        if (!this.overlayRef) return;

        const refRect = this.reference.getBoundingClientRect();
        this.overlayRef.updateSize({ width: refRect.width });
    }

    protected getOverlayConfig(): OverlayConfig {
        const positionStrategy = this.overlay
            .position()
            .flexibleConnectedTo(this.reference)
            .withPush(false)
            .withPositions([
                {
                    originX: 'start',
                    originY: 'top',
                    overlayX: 'start',
                    overlayY: 'top',
                },
            ]);

        const scrollStrategy = this.overlay.scrollStrategies.reposition();

        return new OverlayConfig({
            positionStrategy,
            scrollStrategy,
            hasBackdrop: true,
            backdropClass: 'cdk-overlay-transparent-backdrop',
            panelClass: 'bciti-select-list-overlay',
        });
    }
}
